import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import { injectIntl } from "react-intl";
import { CHECKOUT_FORM_NAME_MOUNTPOINT } from "../../utils/constants";
import styles from "./CheckoutForm.scss";
import classnames from "classnames";
import constants from "../../utils/constants";
import { CustomerForm, PaymentForm } from "~/components";
import CheckoutAdditionalInfo from "../CheckoutAdditionalInfo/CheckoutAdditionalInfo";

function CheckoutForm({
  fields,
  messages,
  handleSubmit,
  countries,
  invalid,
  fieldConfiguration,
  creditCardTypes,
  paymentType,
  paymentTickersAvailable,
  pendingTotal,
  bookingTotalRate,
  depositTotal,
  bookingOriginalRate,
  depositOriginalRate,
  pendingOriginal,
  submitting,
  loading,
  currency,
  onSelectPaymentType,
  propertyTicker,
  media,
  handleGallery,
  defaultCurrency,
  handleModalContent,
  handleCloseModal,
  propertyContact,
  propertyName,
  cancelableUntilList,
  handleConditions,
  showTransferDefaultMessage,
  pendingAmountTextConfiguration,
  handleAddReservation,
  paypalButton,
  handleShareBookingCart,
  fullWidth,
  iframeMode,
  idReservation,
  handlePCIProxySubmit,
  pciProxyError,
  createPCIProxyError,
  communicationsDisclaimer,
  privacyPolicy,
  cancelRelease,
  reservationStartDate,
  arePaymentsAvailables,
  reservations,
  guestFormQuestionnaire,
  updateCustomFormValues,
  isFormValid,
  isCustomFormValid,
  reservationsDates,
  touchFormGenerator,
  touchOnSubmit,
  locale,
  availablePayments,
  selectedPayment,
  hideDefaultPrivacyPolicy,
  transferInfo,
  createPnPV2PaymentOrder,
  tokenizePnPV2Error,
  paymentError,
  formAsyncValidationErrors,
  pnpV2PaymentToken,
  createPnPV2PaymentOrderSuccess,
  createPnPV2PaymentOrderError,
  taxesText,
  expiration,
  affiliateIsEncoded,
  affiliate,
  cancellationRestrictions,
  cancellationPoliciesInfo,
  originalTotalTax,
  originalTotalCityTax,
}) {
  let pendingAmount = pendingOriginal;

  if (!pendingAmount) {
    pendingAmount = 0;
  }

  let depositAmount = depositOriginalRate;

  if (!depositAmount) {
    depositAmount = 0;
  }
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div id="formContainer" className={classnames("wbkv9-CheckoutForm", styles.formContainer)}>
          {!fullWidth && (
            <CheckoutAdditionalInfo
              className={!iframeMode && "mobile"}
              media={media}
              pendingTotal={pendingTotal}
              bookingTotalRate={bookingTotalRate}
              depositTotal={depositTotal}
              bookingOriginalRate={bookingOriginalRate}
              depositOriginalRate={depositOriginalRate}
              pendingOriginal={pendingOriginal}
              currency={currency}
              defaultCurrency={defaultCurrency}
              propertyContact={propertyContact}
              propertyName={propertyName}
              creditCardTypes={creditCardTypes}
              cancelableUntilList={cancelableUntilList}
              handleModalContent={handleModalContent}
              handleConditions={handleConditions}
              pendingAmountTextConfiguration={pendingAmountTextConfiguration}
              handleAddReservation={handleAddReservation}
              handleShareBookingCart={handleShareBookingCart}
              handleGallery={handleGallery}
              iframeMode={iframeMode}
            />
          )}
          <CustomerForm
            countries={countries}
            fields={fields}
            fieldConfiguration={fieldConfiguration}
            messages={
              messages ? messages.get(constants.MESSAGE_POSITIONS.BELOW_PERSONAL_INFO_STEP_2) : null
            }
            propertyTicker={propertyTicker}
            communicationsDisclaimer={communicationsDisclaimer}
            handleModalContent={handleModalContent}
            reservations={reservations}
            guestFormQuestionnaire={guestFormQuestionnaire}
            updateCustomFormValues={updateCustomFormValues}
            isFormValid={isFormValid}
            reservationsDates={reservationsDates}
            touchFormGenerator={touchFormGenerator}
            handleCloseModal={handleCloseModal}
          />
          <PaymentForm
            creditCardTypes={creditCardTypes}
            fields={fields}
            invalid={invalid}
            submitting={submitting}
            loading={loading}
            fieldConfiguration={fieldConfiguration}
            paymentType={paymentType}
            paymentTickersAvailable={paymentTickersAvailable}
            onSelectPaymentType={onSelectPaymentType}
            messages={
              messages ? messages.get(constants.MESSAGE_POSITIONS.TOP_METHOD_PAYMENT_STEP_2) : null
            }
            propertyTicker={propertyTicker}
            handleConditions={handleConditions}
            depositTotal={depositTotal}
            showTransferDefaultMessage={showTransferDefaultMessage}
            paypalButton={paypalButton}
            onSubmit={handleSubmit}
            idReservation={idReservation}
            privacyPolicy={privacyPolicy}
            propertyName={propertyName}
            handlePCIProxySubmit={handlePCIProxySubmit}
            pciProxyError={pciProxyError}
            createPCIProxyError={createPCIProxyError}
            handleModalContent={handleModalContent}
            handleCloseModal={handleCloseModal}
            currency={currency}
            defaultCurrency={defaultCurrency}
            totalAmount={bookingOriginalRate}
            pendingAmount={pendingAmount}
            depositAmount={depositAmount}
            bookingTotalRate={bookingTotalRate}
            defaultTotalAmount={bookingOriginalRate}
            cancelRelease={cancelRelease}
            reservationStartDate={reservationStartDate}
            arePaymentsAvailables={arePaymentsAvailables}
            isCustomFormValid={isCustomFormValid}
            touchOnSubmit={touchOnSubmit}
            locale={locale}
            availablePayments={availablePayments}
            selectedPayment={selectedPayment}
            hideDefaultPrivacyPolicy={hideDefaultPrivacyPolicy}
            transferInfo={transferInfo}
            createPnPV2PaymentOrder={createPnPV2PaymentOrder}
            tokenizePnPV2Error={tokenizePnPV2Error}
            paymentError={paymentError}
            formAsyncValidationErrors={formAsyncValidationErrors}
            pnpV2PaymentToken={pnpV2PaymentToken}
            createPnPV2PaymentOrderSuccess={createPnPV2PaymentOrderSuccess}
            createPnPV2PaymentOrderError={createPnPV2PaymentOrderError}
            taxesText={taxesText}
            expiration={expiration}
            affiliateIsEncoded={affiliateIsEncoded}
            affiliate={affiliate}
            reservations={reservations}
            cancellationRestrictions={cancellationRestrictions}
            cancellationPoliciesInfo={cancellationPoliciesInfo}
            originalTotalTax={originalTotalTax}
            originalTotalCityTax={originalTotalCityTax}
          />
        </div>
      </form>
    </div>
  );
}

CheckoutForm.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(pure(CheckoutForm));
